var exports = {
  "p_": "xa15a2ab7--45cf3d--list",
  "UU": "xa15a2ab7--45cf3d--name",
  "Uq": "xa15a2ab7--45cf3d--value",
  "AS": "xa15a2ab7--45cf3d--item",
  "Vg": "xa15a2ab7--45cf3d--grid",
  "_7": "xa15a2ab7--45cf3d--grid-2",
};

module.exports = exports;
